import {
  SET_CLASSIFICATION_FORMS, SET_AFFECTED_VEHICLES_FORMS, SET_RECIPIENTS_FORMS, SET_VOLUMES_FORMS, SET_ATTACHMENTS_FORMS,
  SET_SOFTWARE_FORMS, SET_SUMMARY_FORMS, SET_SUBCRFEEDBACK_FORMS, SET_CAMPAIGN_STATUSES_FORMS, SET_SUBCAMPAIGN_STATUSES_FORMS,
  SET_LANGUAGES_FORM, SET_PLANTS_FORM, SET_DESCRIPTION_FORMS, SET_FORMS,
} from '../types';

export const setForms = (forms) => ({
  type: SET_FORMS,
  payload: forms,
});

export const setDescriptionForms = (descriptionForms) => ({
  type: SET_DESCRIPTION_FORMS,
  payload: descriptionForms,
});

export const setClassificationForms = (classificationForms) => ({
  type: SET_CLASSIFICATION_FORMS,
  payload: classificationForms,
});

export const setSoftwareForms = (softwareForms) => ({
  type: SET_SOFTWARE_FORMS,
  payload: softwareForms,
});

export const setAffectedVehiclesForms = (affectedVehiclesForms) => ({
  type: SET_AFFECTED_VEHICLES_FORMS,
  payload: affectedVehiclesForms,
});

export const setVolumesForms = (volumesForms) => ({
  type: SET_VOLUMES_FORMS,
  payload: volumesForms,
});

export const setRecipientsForms = (recipientsForms) => ({
  type: SET_RECIPIENTS_FORMS,
  payload: recipientsForms,
});

export const setAttachmentsForms = (attachmentsForms) => ({
  type: SET_ATTACHMENTS_FORMS,
  payload: attachmentsForms,
});

export const setSummayForms = (summaryForms) => ({
  type: SET_SUMMARY_FORMS,
  payload: summaryForms,
});

export const setSubCRFeedbackForms = (subCrFeedbackForms) => ({
  type: SET_SUBCRFEEDBACK_FORMS,
  payload: subCrFeedbackForms,
});

export const setCampaignStatusesForms = (campaignStatusesForms) => ({
  type: SET_CAMPAIGN_STATUSES_FORMS,
  payload: campaignStatusesForms,
});

export const setSubCampaignStatusesForms = (subCampaignStatusesForms) => ({
  type: SET_SUBCAMPAIGN_STATUSES_FORMS,
  payload: subCampaignStatusesForms,
});

export const setLanguagesForm = (languagesForm) => ({
  type: SET_LANGUAGES_FORM,
  payload: languagesForm,
});

export const setPlantsForm = (plants) => ({
  type: SET_PLANTS_FORM,
  payload: plants,
});
